import {useGraphql} from "@/core/graphql/service";
import {useScopeQuery} from "@/core/store/scopeQuery";
import {Order} from "@/gql/gen";
import orderHistoryQuery from "@/gql/gen/query/orderHistoryQuery";
import {saleOrderActiveListQuery} from "@/gql/gen/query/saleOrderActiveListQuery";
import useOrder from "@/modules/shop/composable/useOrder";
import {defineStore} from "pinia";
import {computed, ref, triggerRef} from "vue";

const STORE_NAME = "shop-orders";

export const useOrdersStore = defineStore(STORE_NAME, () => {
    const {registerScopeQuery} = useScopeQuery();
    const {useLazyQuery} = useGraphql();

    const ordersActiveRaw = ref<Order[]>([]);
    const ordersActive = computed(() => ordersActiveRaw.value.map(order => useOrder(order)))

    const ordersHistoryRaw = ref<Order[]>([]);
    const ordersHistory = computed(() => ordersHistoryRaw.value.map(order => useOrder(order)))

    registerScopeQuery(
        STORE_NAME,
        "user",
        {
            sale_order_active_list: {
                __fragment: "OrderFields",
            },
        },
        (data) => {
            if (data.sale_order_active_list) {
                ordersActiveRaw.value = data.sale_order_active_list;
                activeOrdersRequest.setResult(data.sale_order_active_list)
            }
        }
    );

    const activeOrdersRequest = useLazyQuery(saleOrderActiveListQuery({
        __fragment: 'OrderFields'
    }), {
        name: 'orders_active',
        initialResult: () => ordersActiveRaw.value,
        onResult: (result) => {
            ordersActiveRaw.value = result
        },
        cache: 1000 * 60,
        pollingInterval: 1000 * 60,
    })

    const historyOrdersRequest = useLazyQuery(orderHistoryQuery({
        __fragment: 'OrderFields'
    }), {
        name: 'orders_history',
        onResult: (result) => {
            ordersHistoryRaw.value = result
        },
        cache: 1000 * 60 * 30, // Кеш на 5 минут для истории
    })

    const getActiveOrderOrFetch = async (id: number) => {
        let order = ordersActive.value.find(order => order.ID === id)
        if (!order) {
            const orders = await activeOrdersRequest.query()
            if (orders) {
                order = ordersActive.value.find(order => order.ID === id)
            }
        }
        return order
    }

    const setActiveOrders = (orders: Order[]) => {
        ordersActiveRaw.value = orders
        triggerRef(ordersActiveRaw)
        console.log('setActiveOrders', orders)
    }

    return {
        ordersActive,
        ordersHistory,
        activeOrdersRequest,
        historyOrdersRequest,
        getActiveOrderOrFetch,
        setActiveOrders
    };
});
